<template>
	<div>
		<b-modal id="modal-input" scrollable :no-close-on-backdrop=true :title="'Advance Filter'" :no-close-on-esc=true v-model="isFilterShow"
				 :dialog-class="''"
				 :ok-title="'Search'"
				 ok-variant="success"
				 :cancel-title="'Clear'"
				 @ok="getPartPurchaseQualityControlConfirmations"
				 @hidden="resetModal">
			<b-card>
				<b-row>
					<b-col cols="12" lg="6">
					<!-- <app-input-combobox-autocomplete :options="partPurchaseQualityControls" optionsLabel="partPurchaseQualityControlDate" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Part Purchase Quality Control" id="filter-" size="sm" :model.sync="filter.partPurchaseQualityControlId" @input="getPartPurchaseQualityControls" @focus="getPartPurchaseQualityControls" /> -->
					<app-input-textbox id="fieldset-part-purchase-quality-control-confirmation-number" label-cols-sm="4" label-cols-lg="3" label="Part Purchase Quality Control Confirmation Number" label-for="filter-part-purchase-quality-control-confirmation-number" size="sm" :model.sync="filter.partPurchaseQualityControlConfirmationNumber" />
					</b-col>
					<b-col cols="12" lg="6">
					<app-input-datepicker-range  id="fieldset-part-purchase-quality-control-confirmation-date" label-cols-sm="4" label-cols-lg="3" label="Part Purchase Quality Control Date" size="sm" :modelFrom.sync="filter.partPurchaseQualityControlConfirmationDateFrom" :modelTo.sync="filter.partPurchaseQualityControlConfirmationDateTo" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" reset-button />
					</b-col>
					<b-col cols="12" lg="6">

						<b-button variant="danger" v-if="false" size="sm" class="float-right" @click="resetFilter"><span style="font-size: 0.75rem" class="mr-1"><b-icon-x></b-icon-x></span> Clear Filter</b-button>
						<b-button variant="primary" v-if="false" size="sm" class="float-right mr-1" @click="getPartPurchaseQualityControlConfirmations"><span style="font-size: 0.75rem" class="mr-1"><b-icon-search></b-icon-search></span> Cari</b-button>
					</b-col>
				</b-row>
			</b-card>
			<template #modal-footer="{ ok }">
				<b-button size="sm" class="btn-default-white float-right" @click="resetFilter()">
					Clear
				</b-button>
				<b-overlay :show="isDataLoading"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right ">
					<b-button size="sm" class="float-right btn-default" @click="ok()">
						Search
					</b-button>
				</b-overlay>
			</template>
		</b-modal>

		<div>
			<b-row class="mb-2 d-sm-none d-md-flex">
				<b-col class="pt-1">
					<span class="function-title">Part Purchase Quality Control Confirmation</span>
				</b-col>
				<b-col>
					<span class="float-right">
						<!-- <b-dropdown text="Action" class="m-md-2 btn-action-more" size="sm">
<b-dropdown-item v-if="(userRole != null ? userRole.allowDownload : false)" href="/files/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation.xlsx"><b-icon-wallet class="mr-1"></b-icon-wallet> Download Template</b-dropdown-item>
<b-dropdown-item v-if="(userRole != null ? userRole.allowUpdate : false)" @click="showPopupUploadData"><b-icon-upload class="mr-1"></b-icon-upload> Upload Data</b-dropdown-item>
							<b-dropdown-item v-if="(userRole != null ? userRole.allowPrint : false)" @click="printData"><b-icon-printer class="mr-1"></b-icon-printer> Export To Pdf</b-dropdown-item>
						</b-dropdown>
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay> -->

					</span>
					<Portal to="app-navbar-bottom">
						<span class="float-right">
                        <b-overlay v-if="(userRole != null ? userRole.allowCreate : false)"
                                   :show="isCreateBusy"
                                   opacity="0.6"
                                   spinner-small
                                   spinner-variant="default"
                                   class="d-inline">
                            <b-button class="btn-create btn-fill-success" @click="createData" size="sm"> <b-icon-plus-square class="mr-1"></b-icon-plus-square>Create New</b-button>
                        </b-overlay>

						</span>
					</Portal>
				</b-col>
			</b-row>
			<div class="table-corner">
				<div class="table-action-button">
					<!-- <b-button class="btn-action d-sm-none d-md-inline" size="sm" @click="downloadData"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>

					<b-overlay v-if="isShowDeleteButton"
						:show="isDeleteBusy"
						rounded
						opacity="0.6"
						spinner-small
						spinner-variant="primary"
						class="d-inline-block">
						<click-confirm>
							<b-button class="btn-action" @click="deleteMultipleData" size="sm"><b-icon-trash class="mr-1"></b-icon-trash> Delete</b-button>
						</click-confirm>
					</b-overlay> -->

					<b-button v-if="isShowAdvanceFilterButton" class="btn-action" size="sm" @click="isFilterShow = true"><b-icon-search class="mr-1"></b-icon-search> {{ 'Advance Filter' | countFilter(filter) }} </b-button>
					<span class="d-inline d-md-none">
						<b-button v-if="!isStacked" class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = true"><b-icon-view-stacked></b-icon-view-stacked></b-button>
						<b-button v-else class="btn-action float-right btn-action-scroll" size="sm" @click="isStacked = false"><b-icon-table></b-icon-table></b-button>
					</span>
					<span>
						<b-button :disabled="isPullRight" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollRight"><b-icon-caret-right-fill></b-icon-caret-right-fill></b-button>
						<b-button :disabled="isPullLeft" class="btn-action float-right btn-action-scroll" size="sm" @click="scrollLeft"><b-icon-caret-left-fill></b-icon-caret-left-fill></b-button>
					</span>
				</div>
				<b-table sticky-header="565px" :stacked="isStacked" id="table-list-partpurchasequalitycontrolconfirmation" :class="'table-action ' + (isStacked ? '' : 'table-index')" head-variant="head-light" :bordered="true" :no-local-sorting="true" :items="partPurchaseQualityControlConfirmations" :fields="fields" :busy="isDataLoading" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" small responsive show-empty :tbody-tr-class="rowClass">
					<template #empty>
						<app-no-data-image />
					</template>
					<template #table-busy v-if="partPurchaseQualityControlConfirmations.length <= 0">
						<app-no-data-image :animate="true" />
					</template>
					<template v-slot:head(front-action)>
						<b-button @click="isShowFilter = !isShowFilter" size="sm" class="btn-filter float-right"><b-icon-funnel /></b-button>
					</template>
					<template #top-row v-if="isShowFilter">
						<b-th></b-th>
						<b-th></b-th>
				<!-- <b-th stacked-heading="Part Purchase Quality Control" class="table-filter">
					<v-select append-to-body label="partPurchaseQualityControlDate" :options="partPurchaseQualityControls" :value="filter.partPurchaseQualityControlId" :reduce="item => item.id" v-model="filter.partPurchaseQualityControlId" :filterable="true" @input="getPartPurchaseQualityControlConfirmationsWithoutLoading" @search="getPartPurchaseQualityControls"></v-select>
				</b-th> -->
				<b-th stacked-heading="Part Purchase Quality Control Confirmation Number" class="table-filter">
					<b-form-input id="input-part-purchase-quality-control-confirmation-number-table" @input="getPartPurchaseQualityControlConfirmationsWithoutLoading" v-model="filter.partPurchaseQualityControlConfirmationNumber" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Purchase Quality Control Date" class="table-filter">
					<b-form-datepicker boundary="viewport" placeholder="" id="input-part-purchase-quality-control-confirmation-date-from-table" reset-button @input="getPartPurchaseQualityControlConfirmationsWithoutLoading" v-model="filter.partPurchaseQualityControlConfirmationDateFrom" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
					<b-form-datepicker boundary="viewport" placeholder="" id="input-part-purchase-quality-control-confirmation-date-to-table" reset-button @input="getPartPurchaseQualityControlConfirmationsWithoutLoading" v-model="filter.partPurchaseQualityControlConfirmationDateTo" size="sm" :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"></b-form-datepicker>
				</b-th>
				<b-th></b-th>

						<!-- <b-th stacked-heading="Select All">
							<b-form-checkbox v-if="(userRole != null ? userRole.allowPrint : false)" id="input-select-all" class="float-right d-block d-md-none" v-model="selectAll"></b-form-checkbox>
						</b-th> -->
					</template>
					<template v-slot:cell(no)="row">
						{{ ((row.index + 1) + ( pageSizeOptions * (currentPage - 1))) }}
					</template>

					<template v-slot:cell(partpurchasequalitycontrolconfirmationnumber)="row">
						<a @click="() => ( $router.push({ name: 'partpurchasequalitycontrolconfirmationdetail', params : { id: row.item.id } }))" class="a-link-detail">
							{{ row.item.partPurchaseQualityControlConfirmationNumber != null && row.item.partPurchaseQualityControlConfirmationNumber != "" ?
								(typeof row.item.productCode == 'string') ?
									row.item.partPurchaseQualityControlConfirmationNumber.slice(0, 30) + (row.item.partPurchaseQualityControlConfirmationNumber.length > 30 ? "..." : "" ) : row.item.partPurchaseQualityControlConfirmationNumber : "" }}
						</a>
					</template>

			<template v-slot:cell(partPurchaseQualityControl)="row">
				{{ row.item.partPurchaseQualityControl != null ? row.item.partPurchaseQualityControl.partPurchaseQualityControlDate : "" }}
			</template>
			<template v-slot:cell(partPurchaseQualityControlConfirmationDate)="row">
				{{ row.item.partPurchaseQualityControlConfirmationDate | moment("DD-MMM-YYYY") }}
			</template>

					<template v-slot:cell(front-action)="row">
						<div class="d-flex justify-content-center ml-2">
							<!-- <b-form-checkbox :id="'input-is-checked-' + (row.index + 1)" @change="toggleSelect(Number(row.item.id))" :checked="checkAllData.includes(Number(row.item.id))"></b-form-checkbox> -->
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<span>
							<b-button size="sm" @click="row.toggleDetails" class="mr-2 btn-sm btn-transparent border-0">
								<b-icon-chevron-down v-if="!row.detailsShowing"></b-icon-chevron-down>
								<b-icon-chevron-up v-else></b-icon-chevron-up>
							</b-button>
						</span>
					</template>
					<template #row-details="row">
						<b-card>
						<app-input-datepicker  id="fieldset-part-purchase-quality-control-confirmation-date" label-cols-lg="12"  label="Part Purchase Quality Control Date" size="sm" :model.sync="row.item.partPurchaseQualityControlConfirmationDate"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB"  :isEditable="false" :isUpdatable="true" />

						</b-card>
					</template>
				</b-table>
			</div>
			<b-row>
				<b-col cols="12" class="paging-container">
					<div>
						<b-row>
							<b-col cols="12">
								<b-pagination class="btn-paging paging-page-size"
									v-model="currentPage"
									:total-rows="(partPurchaseQualityControlConfirmationsPaging != null ? partPurchaseQualityControlConfirmationsPaging.dataCount : 0)"
									:per-page="(partPurchaseQualityControlConfirmationsPaging != null ? partPurchaseQualityControlConfirmationsPaging.pageSize : 0)"
									aria-controls="my-table">
									<template #first-text>
										<b-icon-chevron-left />
									</template>
									<template #prev-text>
										Prev
									</template>
									<template #next-text>
										Next
									</template>
									<template #last-text>
										<b-icon-chevron-right />
									</template>
								</b-pagination>
								<span class="paging-page-size">
									<b-form-select v-if="false" v-model="pageSizeOptions" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
									<b-dropdown :text="pageSizeOptions + ' per page'" class="m-md-2 btn-paging-size" size="sm">
										<b-dropdown-item v-for="item in pagingOptions" :key="item.value" @click="pageSizeOptions = item.value">
											{{ item.text }}
										</b-dropdown-item>
									</b-dropdown>
								</span>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
		</div>
        <Upload :openPopup="showPopupUpload"
            @resetMethod="resetModalUpload"
            @uploadButtonMethod="uploadData" />
        <PopupDownload :openPopup="showPopupDownload"
            :processId="processId"
            @resetModalMethod="resetModal"
            label="Popup Download"
            :contentLabel="popupDownloadLabel" />
        <PopupPDF :openPopup="isShowPopupPDF"
            :pdfUrl="pdfUrl"
            @resetModalMethod="resetModal"
            label="Popup PDF" />
        <PopupDataEditNotification entityName="approvalconfiguration"
            :dataId="currentDataId"
            @resetModalMethod="resetModal"
            label="Data Recovery" />
		<RouterView />
	</div>
</template>
<style lang="scss" scoped>
	@import '../../assets/scss/index-page.scss';

    ::v-deep #table-list-partpurchasequalitycontrolconfirmation.b-table.b-table-stacked > tbody > tr > td.th-front-action::before {
        background-image: url(/img/box-checklist.png);
        background-size: 40px 40px;
        display: block;
        width: 40px;
        height: 40px;
        content: "";
        margin-bottom: 10px;
    }

	::v-deep #table-list-partpurchasequalitycontrolconfirmation.b-table>thead>tr>th {
		background: #e28b29;
	}

    ::v-deep #table-list-partpurchasequalitycontrolconfirmation.b-table.b-table-stacked > tbody > tr > td.th-front-action > div {
        display: flex;
    }
</style>
<script>
import PartPurchaseQualityControlConfirmation from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmation';
import PartPurchaseQualityControlConfirmationList from '@/models/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationList';
import PartPurchaseQualityControlConfirmationFilter from '@/filters/PartPurchaseQualityControlConfirmation/PartPurchaseQualityControlConfirmationFilter';
import RoleDetail from '@/models/Core/RoleDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import AppInputCombobox from '@/components/AppInputCombobox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PartPurchaseQualityControlFilter from '@/filters/PartPurchaseQualityControl/PartPurchaseQualityControlFilter';
import PartPurchaseQualityControl from '@/models/PartPurchaseQualityControl/PartPurchaseQualityControl';
import AppLabel from '@/components/AppLabel';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardStatusFilter from '@/filters/ControlCardStatus/ControlCardStatusFilter';
import ControlCardStatus from '@/models/ControlCardStatus/ControlCardStatus';
import PopupDownload from '@/components/PopupDownload';
import PopupPDF from '@/components/PopupPDF';
import PopupDataEditNotification from '@/components/PopupDataEditNotification';
import Upload from './Upload';
import AppInputTextbox from '@/components/AppInputTextbox';

export default {
	components : {
		PartPurchaseQualityControlConfirmation, 
		PartPurchaseQualityControlConfirmationList, 
		PartPurchaseQualityControlConfirmationFilter, 
		AppInputTextarea,
		AppInputComboboxAutocomplete,
		AppInputCombobox,
		AppLabel,
		AppInputDatepicker,
		AppInputDatepickerRange,
		PopupDownload,
		PopupPDF,
		Upload,
		PopupDataEditNotification,
		AppInputTextbox,
	},
	data() {
		return {
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fields: [
				{"front-action": { "class" : "th-front-action", "label" : ""}},
				{"no" : {"class" : "th-number d-stack-none"}},
				//{"partPurchaseQualityControl": {}, "class" : "th-part-purchase-quality-control first-child", "label" : "Part Purchase Quality Control", key: 'partPurchaseQualityControl', sortable: true}, 
				{"partPurchaseQualityControlConfirmationNumber": {}, "class" : "th-part-purchase-quality-control-confirmation-number", "label" : "Part Purchase Quality Control Confirmation Number", key: 'partPurchaseQualityControlConfirmationNumber', sortable: true}, 
				{"partPurchaseQualityControlConfirmationDate": {}, "class" : "th-part-purchase-quality-control-confirmation-date last-child", "label" : "Part Purchase Quality Control Date", key: 'partPurchaseQualityControlConfirmationDate', sortable: true}, 
				{"revisi": {}, "class" : "th-revisi d-stack-none", "label" : "Revisi", key: 'revisi', sortable: true}, 

				{"actions": {"class" : "th-actions d-stack-show", "label" : ""}}
			],
			yesNoCombo: [
				{ id : 'TRUE', name : 'True', selected:true },
				{ id : 'FALSE', name : 'False' },
			],
			busy:false,
			isDataLoading: false,
			isDownloadDataBusy: false,
			isMultiplePrintBusy: false,
			showPopupUpload: false,
			showPopupDownload: false,
			isShowPopupPDF: false,
			pdfUrl: "",
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			filter: null,
			processId: "",
			popupDownloadLabel: "",
			hasLoadedData: false,
			showFilter: false,
			isShowFilter: false,
			isCreateBusy: false,
			btnEditData: [],
			currentDataId: null,
			selectedModel: null,
			partPurchaseQualityControlConfirmations: [],
			partPurchaseQualityControlConfirmationsPaging: {},
			partPurchaseQualityControls : [],
			partPurchaseQualityControlConfirmationDetails : [],

			isApprovalBusy: false,
			isFilterShow: false,
			isDeleteBusy: false,
			isPullRight: false,
			isPullLeft: true,
			isStacked: false,
			isScannerMode: false,
		}
	},	methods : {
		getPartPurchaseQualityControlConfirmations : async function() {
			this.isDataLoading = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartPurchaseQualityControlConfirmation.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControlConfirmations = result.data
					this.partPurchaseQualityControlConfirmationsPaging = result
				}
				this.isDataLoading = false;
			})
			.catch(error => {
				this.isDataLoading = false;
			});
		},
		getPartPurchaseQualityControlConfirmationsWithoutLoading : async function() {
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}

			PartPurchaseQualityControlConfirmation.getList(this, this.filter, this.sortingBy, (this.currentPage - 1), this.pageSizeOptions)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControlConfirmations = result.data
					this.partPurchaseQualityControlConfirmationsPaging = result
				}
			})
			.catch(error => {});
		},
		getPartPurchaseQualityControls : async function(input) {
			let filter = new PartPurchaseQualityControlFilter();
			if (input != undefined) {
				filter.partPurchaseQualityControlDate = input;
			}
			PartPurchaseQualityControl.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPurchaseQualityControls = result.data
				}
			})
			.catch(error => {});
		},

		resetFilter() {
			this.filter = new PartPurchaseQualityControlConfirmationFilter();
			this.getPartPurchaseQualityControlConfirmations();
			this.isFilterShow = false;
		},
		showPopupUploadData() {
			this.showPopupUpload = true;
		},
		uploadData(modalEvent) {
			this.showPopupUpload = false;
		},
		resetModal() {
			this.showPopupUpload = false;
			this.showPopupDownload = false;
			this.isShowPopupPDF = false;
			this.isFilterShow = false;
		},
		resetModalUpload() {
			this.showPopupUpload = false;
			this.getPartPurchaseQualityControlConfirmations();
		},
		toggleSelect(id) {
			if (this.checkAllData.includes(id)) {
				this.$store.dispatch("removeCheckData", id);
			} else {
				this.$store.dispatch("addCheckData", id);
			}
		},
		showPopupPrint(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di cetak";
			this.processId = id;
		},
		showPopupDownloadData(id) {
			this.showPopupDownload = true;
			this.popupDownloadLabel = "Mempersiapkan data untuk di unduh";
			this.processId = id;
		},
		showPopupPDF(url) {
			this.isShowPopupPDF = true;
			this.pdfUrl = url;
		},
		printData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isMultiplePrintBusy = true;
				PartPurchaseQualityControlConfirmation.multiPagePrint(this).then(result => {
					if (result) {
						this.showPopupPrint(result.id);
					}
				this.isMultiplePrintBusy = false;
				}).catch(error => { this.isMultiplePrintBusy = false; });
			}
		},
		printSingleData(id) {
			PartPurchaseQualityControlConfirmation.singleDataPagePrint(this, id).then(result => {
				if (result) {
					this.showPopupPDF(result.download);
				}
			});
		},
		downloadData() {
			this.isDownloadDataBusy = true;
			this.sortingBy = Array();
			if (this.sortBy != null) {
				this.sortingBy[this.sortBy] = this.sortDesc;
			}
			
			console.log('this.filter', this.filter);
			PartPurchaseQualityControlConfirmation.downloadData(this, this.filter, this.sortingBy)
			.then(result => {
				console.log('result ', result);
				if (result) {
					this.showPopupDownloadData(result.id);
				}
				this.isDownloadDataBusy = false;
			})
			.catch(error => { 
				this.isDownloadDataBusy = false; 
			})
		},
		createData() {
			this.isCreateBusy = true;
			PartPurchaseQualityControlConfirmation.createData(this).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						let createRoute = 'partpurchasequalitycontrolconfirmationedit';
						if(this.isScannerMode) {
							createRoute = 'partpurchasequalitycontrolconfirmationscan';
						}

						this.$router.push({ name: createRoute, params : { id: result.id } });
					}
				}
				this.isCreateBusy = false;
			}).catch(error => {
				this.isCreateBusy = false;
			})
		},
		editData(index, id) {
			this.btnEditData[index] = true;
			this.dataId = id;
			PartPurchaseQualityControlConfirmation.editData(this, id).then(result => {
				if (result != null) {
					if (result.id != null && result.id != "") {
						this.$router.push({ name: 'partpurchasequalitycontrolconfirmationedit', params : { id: result.id } });
					}
				}
				this.btnEditData[index] = false;
			}).catch(error => { this.btnEditData[index] = false; })
		},

		deleteData(id) {
			PartPurchaseQualityControlConfirmation.deleteData(this, id).then(result => {
				if (result)
				{
					this.getPartPurchaseQualityControlConfirmations();
				}
			})
		},
		deleteMultipleData() {
			let data = this.$store.state.dataIds;
			if (data.length > 0) {
				this.isDeleteBusy = true;
				PartPurchaseQualityControlConfirmation.deleteMultipleData(this).then(result => {
					this.getPartPurchaseQualityControlConfirmations();
					this.isDeleteBusy = false;
				}).catch(error => { this.isDeleteBusy = false; });
			}
		},
		onResize() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 576) {
				this.isStacked = true;
			} else {
				this.isStacked = false;
			}
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
				this.isShowFilter = true;
			} else {
				this.isShowFilter = this.showFilter;
			}
		},


		scrollRight() {
			var tablePartPurchaseQualityControlConfirmationParent = document.getElementById('table-list-partpurchasequalitycontrolconfirmation').parentNode;
			tablePartPurchaseQualityControlConfirmationParent.scrollLeft += 250;
			this.isPullLeft = false;
			this.isPullRight = false;
			if ((tablePartPurchaseQualityControlConfirmationParent.scrollWidth - tablePartPurchaseQualityControlConfirmationParent.offsetWidth) == Math.ceil(tablePartPurchaseQualityControlConfirmationParent.scrollLeft)) {
				this.isPullRight = true;
			}
		},
		scrollLeft() {
			var tablePartPurchaseQualityControlConfirmationParent = document.getElementById('table-list-partpurchasequalitycontrolconfirmation').parentNode;
			tablePartPurchaseQualityControlConfirmationParent.scrollLeft -= 250;
			this.isPullRight = false;
			this.isPullLeft = false;
			if (tablePartPurchaseQualityControlConfirmationParent.scrollLeft <= 0) {
				this.isPullLeft = true;
			}
		},
		rowClass(item, type) {
			if (!item || type !== 'row') return
			if (this.checkAllData.includes(Number(item.id))) return 'item-active';
		}
	},
	beforeMount() {
		this.$store.dispatch("removeCheckAllData");
		this.filter = new PartPurchaseQualityControlConfirmationFilter();
		this.getPartPurchaseQualityControls()
	},
	mounted(){
		let breadcrumb =[
			"Master Data", 
			"Part Purchase Quality Control Confirmation"
		];
		this.$store.dispatch('setBreadCrumb', breadcrumb);
		this.onResize();
		this.$nextTick(() => {
			this.getPartPurchaseQualityControlConfirmations();
			window.addEventListener('resize', this.onResize);
		});
	},	watch: {
		sortBy: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmations();
			}
		},
		sortDesc: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmations();
			}
		},
		currentPage: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmations();
			}
		},
		pageSizeOptions: {
			handler: function() {
				this.getPartPurchaseQualityControlConfirmations();
			}
		},
		selectAll(newValue) {
			if (newValue) {
				PartPurchaseQualityControlConfirmation.checkAllData(this, this.filter, this.sortingBy);
			} else {
				this.$store.dispatch("removeCheckAllData");
			}
		},
		'$route'(to, from) {
			if (to != null) {
				if (to.name == "partpurchasequalitycontrolconfirmationindex") {
					this.getPartPurchaseQualityControlConfirmationsWithoutLoading();
				}
			}
		},
	},
	computed: {
		checkAllData() {
			return this.$store.state.dataIds;
		},
		userRole() {
			return RoleDetail.query().where("functionInfoId", "part_purchase_quality_control_confirmation").first();
		},
		isShowDeleteButton : function() {
			let userRoleAllowDelete = true;
			if (this.userRole != null) {
				userRoleAllowDelete = this.userRole.allowDelete;
			}
			
			if (window.innerWidth <= 576) {
				if (userRoleAllowDelete) {
					if (this.checkAllData.length > 0) return true;
				}
				return false;
			}

			return userRoleAllowDelete;
		},
		isShowAdvanceFilterButton : function() {
			if (window.innerWidth <= 576) {
				if (this.checkAllData.length <= 0) return true;
				return false;
			}
			return true;
		}
	},	beforeDestroy() {
		this.$store.dispatch("removeCheckAllData");
	},
}
</script>
